import '../scss/jquery.tabify.scss';

/*!
* Tabify - A light-weight, mobile-ready and customizable tab plugin for jQuery
*
* Copyright 2018, Faratech
*
* @author   Faratech
* @license  Licensed under MIT (http://192.168.1.4/FaraTools/plugins/LICENSE)
*
*/
;
(function ($, window, document, undefined) {
    const pluginName = 'tabify',
        p = {};

    p[pluginName] = class {
        constructor(el, config) {
            this.el = el;
            this.$el = $(el);

            this.config = $.extend(true, {}, $.fn[pluginName].defaults, config);

            this.$caller = $(el);
            this.$headerItems = this.getCheckVisibility()
                ? this.$caller.find('> li').filter(':visible')
                : this.$caller.find('> li');
            this.$contentItems = this.getCheckVisibility()
                ? this.$caller.next().find('> li').filter(':visible')
                : this.$caller.next().find('> li');
            this.key = this.$caller.data('key');

            this.init();
        }

        init() {
            this.$caller.addClass(`tabify tabify__theme-${this.getTheme()} tabify__dir-${this.config.dir}`);
            this.wireEvents();

            var curHash = location.hash;
            let currIndex = this.getCurrentIndex();
            
            this.$headerItems.eq(currIndex).trigger('click', true);
            
            if(curHash.toLowerCase().includes(this.$headerItems.eq(currIndex).data('hash'))){
                location.hash = curHash;
            }
        }

        wireEvents() {
            this.$headerItems.on('click', (e, isPageLoad) => {
                let $this = $(e.currentTarget),
                    index = $this.siblings(":visible").addBack().index($this);

                if (typeof this.key !== 'undefined' && this.config.useLocalStorage) {
                    localStorage.setItem(`__tabify_${this.key}`, index);
                }

                this.$caller.trigger('onChange', index);
                if (typeof this.config.onChange === 'function') this.config.onChange.call(e, index);

                this.activeTab(index, isPageLoad);
            });
        };

        getTheme() {
            let data = this.$caller.data('theme');

            return typeof data === 'undefined' ? this.config.theme : data;
        }

        getCheckVisibility() {
            let data = this.$caller.data('check-visibility');

            return typeof data === 'undefined' ? this.config.checkVisibility : data;
        }

        getCurrentIndex() {
            let index = 0;

            let hashIndex = this.$headerItems.index(this.$headerItems.filter(function () {
                return location.hash.toLowerCase().includes($(this).data('hash'))
            }));

            if (hashIndex >= 0)
                index = hashIndex;
            else if (typeof this.config !== 'undefined') {
                if (typeof this.key !== 'undefined' && this.config.useLocalStorage) {
                    let item = localStorage.getItem(`__tabify_${this.key}`);

                    if (item !== null) index = item;

                    if (index > (this.$headerItems.length - 1))
                        index = 0;
                }
            }

            return index;
        }

        activeTab(index, isPageLoad) {
            this.$headerItems.removeClass('tabify__active').eq(index).addClass('tabify__active');
            this.$contentItems.removeClass('tabify__active').eq(index).addClass('tabify__active');

            if (this.config.useJSFramework) {
                let currentTab = this.$headerItems.eq(index);
                if (typeof currentTab.data(this.config.jsFramework) === 'undefined' && !isPageLoad)
                    $(this.config.jsFrameworkContainerClass).removeClass('visible');
                else
                    $(this.config.jsFrameworkContainerClass).addClass('visible');
            }
        }
    }

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new p[pluginName](this, options));
            }
        });
    };

    $.fn[pluginName].defaults = {
        useLocalStorage: true,
        onChange: null,
        theme: 'default',
        dir: 'ltr',
        checkVisibility: true,
        useJSFramework: true,
        jsFramework: 'react',
        jsFrameworkContainerClass: '.js__react-container'
    };
})(jQuery, window, document);